import { z } from 'zod';

import { SCREAMING_SNAKE_CASE_RE } from '../_shared/codes';

export const CardLabelIdSchema = z.guid().brand<'CardLabelId'>();

export type CardLabelId = z.infer<typeof CardLabelIdSchema>;

export const CardLabelCodeSchema = z
  .string()
  .max(50)
  .regex(SCREAMING_SNAKE_CASE_RE, 'Code must be SCREAMING_SNAKE_CASE.')
  .brand<'CardLabelCode'>();

export type CardLabelCode = z.infer<typeof CardLabelCodeSchema>;

const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/;

export const CardLabelColorSchema = z
  .string()
  .regex(HEX_COLOR_RE, 'Color must be a hex value (#RRGGBB or #RRGGBBAA).');

export const CardLabelSchema = z.object({
  id: CardLabelIdSchema,
  code: CardLabelCodeSchema,
  label: z.string().max(100),
  color: CardLabelColorSchema.optional(),
});

export type CardLabel = z.infer<typeof CardLabelSchema>;

export const CardLabelSnapshotSchema = z.object({
  id: CardLabelIdSchema,
  code: CardLabelCodeSchema,
  label: z.string().max(100),
  color: CardLabelColorSchema.optional(),
});

export type CardLabelSnapshot = z.infer<typeof CardLabelSnapshotSchema>;

export const CreateCardLabelInputSchema = z.object({
  code: CardLabelCodeSchema,
  label: z.string().trim().min(1).max(100),
  color: CardLabelColorSchema.optional(),
});

export type CreateCardLabelInput = z.infer<typeof CreateCardLabelInputSchema>;

export const UpdateCardLabelInputSchema = z.object({
  label: z.string().trim().min(1).max(100).optional(),
  color: CardLabelColorSchema.optional(),
});

export type UpdateCardLabelInput = z.infer<typeof UpdateCardLabelInputSchema>;
